import { render, staticRenderFns } from "./IDatePicker.vue?vue&type=template&id=b11923be&scoped=true&"
import script from "./IDatePicker.vue?vue&type=script&lang=js&"
export * from "./IDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11923be",
  null
  
)

export default component.exports